import React from 'react';
var ModalContext = React.createContext({
  onHide: function onHide() {}
});
export default ModalContext;